import { createFileRoute } from "@tanstack/react-router";
import { buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import ComplianceBuildingSettings from "@/components/building_admin/building_admin_settings/compliance";
import { useRouterStore } from "@/store/zustandStore";

export const Route = createFileRoute("/_portal/building/settings/compliance")({
  component: () => {
    const card = {
      icon: "clinical_notes",
      value: "compliance",
      label: "Welcome Compliance",
      enabled: false,
      comingSoon: true,
      to: "/building/settings/compliance",
      descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.COMPLIANCE",
    };
    return (
      <SettingsSubPage
        cardOptions={card}
        PageComponent={ComplianceBuildingSettings}
        label="Compliance"
        path="/building/settings/compliance"
      />
    );
  },
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingOptions);
  },
});
